import { render } from "./NgTrackOrder.vue?vue&type=template&id=2830ee3a"
import script from "./NgTrackOrder.vue?vue&type=script&lang=js"
export * from "./NgTrackOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__